import routes from 'global/Constants/routes';
import { lazy } from 'react';

const PackagingPage = lazy(() => import('../../pages/dashboard/packaging/Packaging'));
const PackagingEditPage = lazy(() => import('../../pages/dashboard/packaging/create/PackagingEditPage'));
const PackagingCreateTabs = lazy(() => import('../../pages/dashboard/packaging/create/PackagingCreatePage'));

export const packagingRoutes = (hasAccessLevel: (_level: number) => boolean) => [
  {
    path: routes.packagingUpdate.path,
    component: PackagingEditPage,
    isPrivate: routes.packagingUpdate.isPrivate,
    accessRole: hasAccessLevel(10),
  },
  {
    path: routes.packagingCreate.path,
    component: PackagingCreateTabs,
    isPrivate: routes.packagingCreate.isPrivate,
    accessRole: hasAccessLevel(10),
  },
  {
    path: routes.packaging.path,
    component: PackagingPage,
    isPrivate: routes.packaging.isPrivate,
    accessRole: hasAccessLevel(10),
  },
];
